<template>
  <!-- The intention's candle (altar redesign 2026-10-27). `light` plays the
       lighting once; the flame then flickers (never under reduced motion). -->
  <svg class="candle" :class="{ light }" viewBox="0 0 14 20" aria-hidden="true">
    <defs>
      <radialGradient :id="gid" cx=".5" cy=".7" r=".6">
        <stop offset="0" stop-color="#fff8e0" />
        <stop offset=".5" stop-color="#ffcf6b" />
        <stop offset="1" stop-color="#f08a2a" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="7" cy="9" r="7" fill="#ffcf6b" opacity=".18" />
    <path class="cf" d="M7 1 C10 5 10 9 7 12 C4 9 4 5 7 1Z" :fill="`url(#${gid})`" />
    <rect x="4.5" y="12" width="5" height="8" rx="1" fill="#e9dcbc" />
  </svg>
</template>

<script setup>
defineProps({ light: { type: Boolean, default: false } })
let n = 0
const gid = `altar-candle-${Date.now().toString(36)}-${++n}-${Math.random().toString(36).slice(2, 6)}`
</script>

<style scoped>
.candle { display: inline-block; width: .55em; height: .8em; margin-right: .35em; vertical-align: -.04em; }
.candle .cf { transform-box: fill-box; transform-origin: 50% 100%; animation: altar-flick 3s ease-in-out infinite; }
.candle.light .cf { animation: altar-lightup 1s ease-out both, altar-flick 3s 1s ease-in-out infinite; }
@keyframes altar-flick { 0%, 100% { transform: scale(1, 1) skewX(0) } 30% { transform: scale(.96, 1.05) skewX(-2deg) } 62% { transform: scale(1.03, .95) skewX(1.5deg) } }
@keyframes altar-lightup { 0% { transform: scale(0); opacity: 0 } 60% { transform: scale(1.3); opacity: 1 } 100% { transform: scale(1) } }
@media (prefers-reduced-motion: reduce) {
  .candle .cf, .candle.light .cf { animation: none; }
}
</style>
